import React, { useEffect, useState } from "react";
import "../Style/Pages/DriverManagement.css";
import search from "../Assets/rider/search.svg";
import Select, { components } from "react-select";
import ham from "../Assets/driver/hamburder.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
import { useSelector } from "react-redux";
import eye from "../Assets/rider/eye.svg";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { TableSkeleton } from "../Component/Skeleton";
const CustomerManagement = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const statusFromUrl = searchParams.get("status");
  const getInitialStatus = (val) => {
    if (val === "true") return true;
    if (val === "false") return false;
    return val || "";
  };
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = useSelector((state) => state?.auth?.permission);
  console.log(auth, "cusAUTH");
  console.log(permission, "cusper");
  const [tpage, setTpage] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const filteroptions = [
    { value: "", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "In Active" },
    { value: true, label: "Block" },
    { value: false, label: "Unblock" },
  ];
  const formatINR = (amount) => {
    if (!amount || amount === 0) return "0";
    return `₹ ${amount.toLocaleString("en-IN")}`
  };

  const [status, setStatus] = useState(getInitialStatus(statusFromUrl));
  const [searchText, setSearchText] = useState("");


  useEffect(() => {
    setStatus(statusFromUrl);
  }, [statusFromUrl]);
  const SingleValueWithLabel = (label) => (props) => (
    <components.SingleValue {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-value">{props.data.label}</span>
    </components.SingleValue>
  );

  const PlaceholderWithLabel = (label) => (props) => (
    <components.Placeholder {...props}>
      <span className="filter-prefix">{label} :</span>
      <span className="filter-placeholder">All</span>
    </components.Placeholder>
  );
  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "36px",
      height: "36px",
      width: "180px",
      minWidth: "180px",
      maxWidth: "180px",
      border: "none",
      borderRadius: "14px",
      paddingLeft: "27px", // space for filter icon
      boxShadow: state.isFocused ? "0 0 0 2px rgba(1,58,40,0.15)" : "none",
      backgroundColor: "white",
      cursor: "pointer",
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
      height: "36px",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#555",
      fontSize: "14px",
      fontWeight: "500",
      margin: 0,
      lineHeight: "36px",
      top: "0",
      transform: "none",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#888",
      fontSize: "14px",
      fontWeight: "500",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#666",
      padding: "0 10px",
      "&:hover": {
        color: "#333",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#013A28"
        : state.isFocused
          ? "#02543a53"
          : "white",
      color: state.isSelected ? "white" : "#333",
      cursor: "pointer",
      ":hover": {
        backgroundColor: state.isSelected ? "#013A28" : "#02543a53",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      zIndex: 9999,
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      maxHeight: "180px",
      overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#013a2826",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#013a2855",
        borderRadius: "3px",
      },
    }),
  };
  const tableHead = [
    "ID",
    "Customer",
    "Phone",
    // "City",
    "Sign Up",
    "Total Rides",
    "Cancelled Rides",
    "Wallet",
    "Total spend",
    "Status",
    "Actions",
  ];

  const [customerlist, setCustomerlist] = useState([]);

  useEffect(() => {
    fetchdrivermanagelist();
  }, [token, page, searchText, status, searchParams]);
  const fetchdrivermanagelist = async () => {
    try {
      setLoading(true);

      const invalidParams = Array.from(searchParams.keys()).some(
        (key) => key !== "status"
      );

      if (invalidParams) {
        setCustomerlist([]);
        setTpage(0);
        toast.error("Invalid URL Parameters Detected");
        return;
      }

      const url =
        status === ""
          ? `/user/getall?limit=10&page=${page}&roletype=user&search=${searchText}`
          : `/user/getall?limit=10&page=${page}&roletype=user&search=${searchText}&status=${status}`;

      const res = await getWithTokenAPI(token, url);
      // const res = await getWithTokenAPI(
      //   token,
      //   `/user/getall?limit=10&page=${page}&roletype=user&search=${searchText}&status=${status}`,
      // );
      setCustomerlist(Array.isArray(res?.data?.data) ? res.data.data : []);
      setTpage(res?.data?.totalpage);
    } catch {
      console.log("Error in fetching Limit Api");
    } finally {
      setLoading(false);
    }
  };
  function formatToDDMMYYYY(isoString) {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  const handleblock = (id, status) => {
    Swal.fire({
      title: `${status ? "Unblock" : "Block"} Rider?`,
      text: `Are you Sure to ${status ? "Unblock" : "Block"} this Rider`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: `${status ? "var(--primary)" : "rgb(186, 28, 28)"}`,
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, ${status ? "Unblock" : "Block"}`,
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleblockdriver(id, status); // your function
      }
    });
  };
  const handleblockdriver = async (id, status) => {
    try {
      const response = await putWithTokenAPI(token, `/user/update/${id}`, {
        blocked: !status,
      });
      if (response?.statusCode === 200) {
        toast.success(
          `Rider ${status ? "UnBlocked" : "Blocked"} Successfully`,
        );
        fetchdrivermanagelist();
      } else {
        toast.error(`Rider Status Update Unsuccessful`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="driverManagement">
      <div className="riderpagetop">
        <span className="ridertophead">Customer Management</span>
        <div className="ridertopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
            />
          </div>
          <div className="filter-select">
            <Select
              value={filteroptions.find((opt) => opt.value === status)}
              options={filteroptions}
              styles={customStyles}
              onChange={(selected) => {
                const newStatus = selected.value;
                setStatus(newStatus);
                setPage(1);
                if (newStatus !== "") {
                  setSearchParams({ status: String(newStatus) });
                } else {
                  setSearchParams({});
                }
              }}
              isSearchable={false}
              menuPlacement="bottom"
              menuPortalTarget={document.body} // 🔥 KEY FIX
              menuPosition="fixed"
              components={{
                SingleValue: SingleValueWithLabel("Status"),
                Placeholder: PlaceholderWithLabel("Status"),
                IndicatorSeparator: null,
              }}
              classNamePrefix="react-select" // 🔴 REQUIRED
            />
          </div>
        </div>
      </div>
      {loading ? (
        <TableSkeleton
          rows={8}
          columns={[
            "ID",
            "Customer",
            "Phone",
            // "City",
            "SignUp",
            "Total Rides",
            "Cancelled Rides",
            "Wallet",
            "Total Spend",
            "Status",
            "Actions",
          ]}
        />
      ) : (
        <div className="driverpagebottom">
          <table className="driverpagetable">
            <thead>
              <tr>
                {tableHead.map((head, index) => (
                  <th key={index}>{head}</th>
                ))}
              </tr>
            </thead>

            {customerlist.length > 0 ? (
              <>
                {" "}
                <tbody>
                  {customerlist.map((row, index) => (
                    <tr key={index}>
                      <td>{row?.customerId}</td>

                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/admin/customerdata/user/${row?._id}`)
                        }
                      >
                        {row?.name || ""}
                      </td>

                      <td>{row?.phoneNumber || ""}</td>
                      {/* <td>{row?.location1?.[0]?.city}</td> */}
                      <td>{formatToDDMMYYYY(row?.createdAt)}</td>

                      <td style={{ textAlign: "center" }}>{row?.totalRides || 0}</td>
                      <td style={{ textAlign: "center" }}>
                        {row?.cancelledRides || 0}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {formatINR(row?.Wallet)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {formatINR(row?.totalSpend)}
                      </td>

                      <td>
                        <span
                          className={`status-text ${row?.status.toLowerCase()}`}
                        >
                          {row?.status || ""}
                        </span>
                      </td>

                      <td className="actions">
                        <img
                          src={eye}
                          onClick={() =>
                            navigate(`/admin/customerdata/user/${row?._id}`)
                          }
                        />
                        <button
                          className={`bub ${row?.blocked ? "" : "red"}`}
                          type="submit"
                          onClick={
                            permission?.customermanagement?.update
                              ? () => handleblock(row._id, row.blocked)
                              : null
                          }
                        >
                          {row?.blocked ? "Unblock" : "Block"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="14">
                      {tpage > 1 && (
                        <div className="pagination">
                          {page > 1 && (
                            <button
                              className="page-btn"
                              onClick={() => setPage((page) => page - 1)}
                            >
                              ‹
                            </button>
                          )}
                          {page > 1 && (
                            <button
                              className="page-btn"
                              onClick={() => setPage(1)}
                            >
                              1
                            </button>
                          )}
                          {page === tpage && (
                            <span className="page-dots">…</span>
                          )}
                          <button className="page-btn pgnoactive">
                            {page}
                          </button>

                          {page !== tpage && (
                            <span className="page-dots">…</span>
                          )}

                          {page !== tpage && (
                            <button
                              className="page-btn"
                              onClick={() => setPage(tpage)}
                            >
                              {tpage}
                            </button>
                          )}

                          {page < tpage && (
                            <button
                              className="page-btn"
                              onClick={() => setPage((page) => page + 1)}
                            >
                              ›
                            </button>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                </tfoot>
              </>
            ) : (
              <tr>
                <td
                  colSpan={10}
                  style={{ textAlign: "center", fontSize: "18px" }}
                >
                  No Customer Data Available
                </td>
              </tr>
            )}
          </table>
        </div>
      )}
    </div>
  );
};

export default CustomerManagement;
